import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// eslint-disable-next-line filenames/match-exported
import { dark } from "../colors/modifiers";
var palette = {
  // Primary
  neptune: "#024ddf",
  neutron: "#2A55D9",
  spotlight: "#ffffff",
  cosmos: "#121212",
  // Secondary
  callisto: "#a733ff",
  jupiter: "#ffb932",
  ganymede: "#21fff2",
  titan: "#fbff2c",
  earth: "#048851",
  mars: "#eb0000",
  // Grey
  granite: "#646464",
  slate: "#949494",
  moonrock: "#bfbfbf",
  ammonite: "#d6d6d6",
  diatomite: "#ebebeb",
  lunar: "#f6f6f6",
  // Inventory
  resale: "#d0006f",
  "package": "#f36c0e"
};
var gradients = {
  mrBlueSky: {
    colorStops: ["#4675e8", palette.neptune],
    toDirection: "90deg",
    fallback: palette.neptune
  },
  justLikeAPill: {
    colorStops: ["#922f90", palette.resale],
    toDirection: "90deg",
    fallback: palette.resale
  },
  ticketFoil: {
    colorStops: [palette.neptune, "#7f6bf4"],
    toDirection: "35deg",
    fallback: palette.neptune
  }
};
var s1 = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  7: 32,
  8: 48,
  9: 64,
  10: 88,
  11: 40
};
var s2 = {
  lounge: s1[1],
  club: s1[2],
  hall: s1[3],
  auditorium: s1[4],
  theatre: s1[5],
  amphitheatre: s1[6],
  arena: s1[7],
  stadium: s1[8],
  dome: s1[9],
  field: s1[10],
  // TODO: Remove for next major version (see GDS-108)
  // deprecated
  compact: s1[1],
  moderate: s1[2],
  medium: s1[3],
  normal: s1[4],
  expanded: s1[6],
  spacious: s1[7],
  giant: s1[11]
};
var space = _objectSpread(_objectSpread({}, s1), s2);
var f1 = {
  0: 12,
  1: 14,
  2: 16,
  3: 18,
  4: 20,
  5: 23,
  6: 26,
  7: 32,
  8: 54
};
var f2 = {
  centi: f1[0],
  uno: f1[1],
  hecto: f1[2],
  kilo: f1[3],
  mega: f1[4],
  giga: f1[5],
  tera: f1[6],
  peta: f1[7],
  exa: f1[8]
};
var fontSizes = _objectSpread(_objectSpread({}, f1), f2);
var _buttons = {
  primary: {
    color: palette.spotlight,
    backgroundColor: palette.neptune
  },
  secondary: {
    color: palette.spotlight,
    backgroundColor: palette.neptune
  },
  tertiary: {
    color: palette.spotlight,
    backgroundColor: palette.cosmos
  },
  inverse: {
    color: palette.cosmos,
    backgroundColor: palette.spotlight
  },
  disabled: {
    color: palette.slate,
    backgroundColor: palette.diatomite
  },
  transaction: {
    color: palette.spotlight,
    backgroundColor: palette.earth
  },
  pill: {
    color: palette.cosmos,
    // This is the teal color used for selected pill buttons
    backgroundColor: palette.ganymede
  }
};
var _header = {
  color: palette.spotlight,
  backgroundColor: palette.neptune
};
var _links = {
  primary: {
    color: palette.neptune
  },
  inverse: {
    color: palette.spotlight
  }
};
var _footer = {
  color: palette.spotlight,
  backgroundColor: palette.cosmos
};
var l1 = {
  width: 135,
  height: 24,
  pathData: "<path d='M41.57 6.27c-4.02 0-6.97 3.63-6.97 7.4 0 3.62 2.38 5.32 5.9 5.32 1.3 0 2.66-.3 3.9-.68l.4-2.5a8.98 8.98 0 0 1-3.75.86c-2.04 0-3.23-.71-3.39-2.62l-.02-.34v-.1a6.46 6.46 0 0 1 .52-2.41c.61-1.55 1.48-2.62 3.36-2.62 1.33 0 2.02.73 2.02 2.03 0 .28-.02.54-.07.83H39.1a7.57 7.57 0 0 0-.34 2.17h7.5c.2-.9.32-1.8.32-2.72 0-3.09-2-4.62-5.02-4.62zm-5.4.28h-4.15l-4.44 4.41h-.05L29.65 1h-3.19l-3.78 17.7h3.11l1.38-6.44h.05l3.16 6.45h3.6l-3.7-6.62 5.88-5.54zm15.16 8.8a5 5 0 0 1 .15-1.18l1.16-5.3h2.86l.5-2.32h-2.86l.79-3.61-3.42 1.1-.55 2.5h-2.3l-.51 2.32h2.3l-.9 4.11c-.2.97-.4 1.89-.4 2.83 0 2.34 1.52 3.2 3.69 3.2.54 0 1.16-.18 1.7-.3l.56-2.45a4.28 4.28 0 0 1-1.55.28c-.72 0-1.22-.44-1.22-1.18zm-47.14 0c0-.47.07-.9.14-1.18l1.16-5.3h2.86l.5-2.32H5.99l.79-3.61-3.43 1.1-.54 2.5H.5L0 8.87h2.3l-.9 4.11c-.21.97-.4 1.89-.4 2.83C1 18.14 2.52 19 4.69 19c.54 0 1.16-.18 1.7-.3l.56-2.45a4.27 4.27 0 0 1-1.55.28c-.71 0-1.22-.44-1.22-1.18zm12.48-1.98c0-2.29 1.42-4.65 3.97-4.65.88 0 1.7.21 2.33.62l.78-2.6a11.4 11.4 0 0 0-3.19-.47c-4.4 0-7.22 3.23-7.22 7.48 0 3.14 2.04 5.24 5.2 5.24 1.05 0 2.1-.1 3.07-.57l.36-2.5c-.83.4-1.81.61-2.6.61-2.18 0-2.7-1.58-2.7-3.16zM14.5 1.31h-3.19l-.67 3.02h3.2l.66-3.02zm-4.36 5.24L7.54 18.7h3.19l2.61-12.16h-3.19zm72.06-.27c-1.43 0-2.81.26-4.17.73l-.45 2.53a9.48 9.48 0 0 1 4.02-.95c1.12 0 2.45.35 2.45 1.58 0 .36 0 .71-.1 1.04h-1.11c-3 0-7.52.3-7.52 4.32 0 2.24 1.57 3.47 3.78 3.47 1.76 0 2.86-.78 3.95-2.15h.05l-.33 1.87h2.68c.29-2.3 1.5-7.06 1.5-8.7 0-2.85-2.3-3.74-4.75-3.74zM80 16.68c-.82 0-1.62-.42-1.62-1.27 0-2.05 2.56-2.31 4.1-2.31h1.13c-.5 1.96-1.24 3.58-3.61 3.58zM71.6 6.27c-1.72 0-3.5.73-4.31 2.31h-.05c-.17-1.47-1.67-2.31-3.12-2.31-1.5 0-2.9.66-3.75 1.9h-.05l.29-1.62h-2.98l-.26 1.35-2.23 10.8h3.18l1.26-5.78c.4-1.63 1-4.2 3.16-4.2.82 0 1.5.57 1.5 1.46 0 .74-.23 1.87-.4 2.6l-1.28 5.93h3.18L67 12.92c.4-1.65.95-4.2 3.17-4.2.8 0 1.5.57 1.5 1.46 0 .74-.24 1.87-.4 2.6l-1.3 5.93h3.2l1.27-5.81c.27-1 .55-2.22.55-3.3a3.4 3.4 0 0 0-3.4-3.33zm41.24 0c-4.02 0-6.97 3.63-6.97 7.4 0 3.62 2.38 5.32 5.9 5.32 1.3 0 2.66-.3 3.9-.68l.4-2.5a9 9 0 0 1-3.75.86c-2.04 0-3.23-.71-3.38-2.62-.01-.12-.03-.22-.03-.34v-.1c.02-.84.2-1.66.53-2.41.6-1.55 1.47-2.62 3.35-2.62 1.33 0 2.02.73 2.02 2.03 0 .28-.02.54-.07.83h-4.36a7.57 7.57 0 0 0-.34 2.17h7.5c.2-.9.32-1.8.32-2.72 0-3.09-2-4.62-5.02-4.62zm10.18 2.57h-.05l.43-2.3h-3.05l-.28 1.64-2.19 10.53h3.19l1.14-5.46c.4-1.96 1.5-3.96 3.76-3.96.4 0 .85.07 1.2.19l.68-3.1a4.9 4.9 0 0 0-1.22-.11c-1.47 0-3.04 1.25-3.61 2.57zm-20.87 6.51c0-.47.07-.9.14-1.18l1.17-5.3h2.85l.5-2.32h-2.85l.78-3.61-3.42 1.1-.55 2.5h-2.3l-.5 2.32h2.3l-.9 4.11c-.22.97-.4 1.89-.4 2.83 0 2.34 1.52 3.2 3.68 3.2.55 0 1.17-.18 1.71-.3l.55-2.45c-.4.17-.98.28-1.55.28-.71 0-1.21-.44-1.21-1.18zm-13.31-5.21c0 3.04 4.13 3.23 4.13 5.2 0 .98-1.12 1.33-2.19 1.33a6.01 6.01 0 0 1-3.04-.94l-.7 2.53a8.8 8.8 0 0 0 3.74.73c2.74 0 5.52-.95 5.52-4.1 0-2.98-4.14-3.55-4.14-5.08 0-.97 1.19-1.23 2.14-1.23.9 0 1.79.26 2.13.44l.69-2.38a13.27 13.27 0 0 0-2.98-.37c-2.53 0-5.3 1.01-5.3 3.87zm43.23-3.86A2.74 2.74 0 0 0 129.33 9c0 1.5 1.23 2.72 2.74 2.72A2.73 2.73 0 0 0 134.81 9c0-1.5-1.23-2.72-2.74-2.72zm.01 5.04A2.23 2.23 0 0 1 129.86 9c0-1.3.95-2.31 2.22-2.31 1.26 0 2.21 1.01 2.21 2.31s-.95 2.32-2.2 2.32zm1.28-3.02c0-.6-.36-.9-1.1-.9h-1.23v3.2h.52V9.17h.44l.9 1.41h.55l-.91-1.4c.5 0 .83-.38.83-.89zm-1.81.48V7.8h.62c.34 0 .66.1.66.47 0 .41-.26.5-.66.5h-.62z'/>"
};
var l2 = {
  viewBox: "0 0 ".concat(l1.width, " ").concat(l1.height)
};
var logoSvg = _objectSpread(_objectSpread({}, l1), l2);
var base = {
  primary: palette.neptune,
  primaryAlt: dark(palette.neptune),
  secondary: palette.callisto,
  border: palette.moonrock,
  borderLight: palette.diatomite,
  borderMidtone: palette.ammonite,
  borderDark: palette.slate,
  bg: palette.spotlight,
  bgAlt: palette.lunar,
  bgInverse: palette.cosmos,
  overlay: "rgba(0, 0, 0, 0.75)",
  overlayText: "rgba(0, 0, 0, 0.50)",
  footerBg: palette.cosmos,
  headerContextBg: palette.cosmos
};
var text = {
  primary: palette.cosmos,
  secondary: palette.granite,
  accent1: palette.callisto,
  accent2: palette.callisto,
  inverse: palette.spotlight,
  link: palette.neptune,
  linkHover: dark(palette.neptune)
};
var status = {
  success: palette.earth,
  warning: palette.jupiter,
  danger: palette.mars,
  info: palette.neptune,
  "default": palette.slate
};
var btn = {
  primary: palette.neptune,
  checkout: palette.earth,
  inverse: palette.spotlight,
  link: palette.neptune,
  vip: palette.jupiter,
  collector: palette.cosmos,
  text: palette.spotlight,
  iconPrimary: palette.neptune,
  iconSecondary: palette.slate
};
var icons = {
  primary: palette.neptune,
  secondary: palette.granite,
  resale: palette.resale,
  selected: palette.spotlight,
  vip: palette.jupiter,
  collector: palette.cosmos
};
var ism = {
  unavailable: {
    section: palette.slate,
    seat: palette.moonrock
  },
  available: palette.neutron,
  selected: palette.earth
};
var badge = {
  active: palette.earth,
  inactive: palette.cosmos,
  "package": palette["package"]
};
var colors = {
  resale: palette.resale,
  highlight: palette.neptune,
  base: base,
  text: text,
  status: status,
  icons: icons,
  ism: ism,
  badge: badge
};
var theme = {
  gradients: gradients,
  space: space,
  fontSizes: fontSizes,
  _buttons: _buttons,
  _header: _header,
  _links: _links,
  _footer: _footer,
  logoSvg: logoSvg,
  base: base,
  text: text,
  status: status,
  btn: btn,
  icons: icons,
  ism: ism,
  badge: badge,
  colors: colors
};
export default theme;